import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"
import {
  getWorkOrders,
  getWorkOrder,
  createWorkOrder,
  updateWorkOrder,
  deleteWorkOrder,
} from "api/workOrderApi"

export const WORK_ORDER_QUERY_KEY = "vehicle-work-orders"

export const useWorkOrders = (params, enabled) =>
  usePaginatedResource(WORK_ORDER_QUERY_KEY, getWorkOrders, params, enabled)

export const useWorkOrder = (id) =>
  useResourceItem(WORK_ORDER_QUERY_KEY, getWorkOrder, id)

export const useCreateWorkOrder = () =>
  useCreateResource(createWorkOrder, WORK_ORDER_QUERY_KEY)

export const useEditWorkOrder = () =>
  useEditResource(updateWorkOrder, WORK_ORDER_QUERY_KEY)

export const useDeleteWorkOrder = () =>
  useDeleteResource(deleteWorkOrder, WORK_ORDER_QUERY_KEY)
